module.exports = __webpack_public_path__ + "img/bg_main_r_3.51de8e04.png";